import { SpeechIcon, StopCircleIcon } from 'lucide-react'
import { useState, useEffect } from 'react'
import 'regenerator-runtime/runtime'
import SpeechRecognition, {
	useSpeechRecognition,
} from 'react-speech-recognition'
import { Button } from '#app/components/ui/button.js'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '#app/components/ui/tooltip'

interface RecorderProps {
	onTranscriptChange: (interimTranscript: string, transcript: string) => void
	onListeningStart?: () => void
	onListeningStop?: () => void
	onReset?: () => void
}

export function Recorder({
	onTranscriptChange,
	onListeningStart,
	onListeningStop,
	onReset,
}: RecorderProps) {
	const [error, setError] = useState<string | null>(null)
	const [isListening, setIsListening] = useState(false)

	const {
		transcript,
		interimTranscript,
		// resetTranscript,
		browserSupportsSpeechRecognition,
	} = useSpeechRecognition()

	useEffect(() => {
		if (!browserSupportsSpeechRecognition) {
			setError('Your browser does not support speech recognition.')
		}
	}, [browserSupportsSpeechRecognition])

	useEffect(() => {
		onTranscriptChange(interimTranscript, transcript)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [interimTranscript, transcript])

	const startListening = async () => {
		try {
			await SpeechRecognition.startListening({ continuous: true })
			setIsListening(true)
			setError(null)
			onListeningStart?.()
		} catch (err) {
			setError(
				'Error starting speech recognition. Please check your microphone permissions.',
			)
			console.error('Speech recognition error:', err)
		}
	}

	const stopListening = () => {
		SpeechRecognition.stopListening()
		setIsListening(false)
		if (onListeningStop) {
			onListeningStop()
		}
	}

	if (!browserSupportsSpeechRecognition) {
		return <div>Speech recognition is not supported in this environment.</div>
	}

	return (
		<div>
			{error && <div className="mb-4 text-red-500">{error}</div>}
			<div>
				<div className="flex items-center justify-between">
					<TooltipProvider>
						<Tooltip>
							<TooltipTrigger asChild>
								<Button
									variant={isListening ? 'destructive' : 'outline'}
									onClick={isListening ? stopListening : startListening}
								>
									{isListening ? (
										<StopCircleIcon className=" mr-2 inline-block h-4 w-4" />
									) : (
										<SpeechIcon className=" mr-2 inline-block h-6 w-6" />
									)}
									{isListening ? 'Stop' : 'Speech'}
								</Button>
							</TooltipTrigger>
							<TooltipContent side="left">
								{isListening
									? 'Stop Listening'
									: 'Speech to Text Transcription'}
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
					{/* <Dialog>
						<DialogTrigger asChild>
							<Button variant="ghost" size={'sm'}>
								Scribe Privacy
							</Button>
						</DialogTrigger>
						<DialogContent>
							<DialogHeader>
								<DialogTitle>Privacy Information</DialogTitle>
								<DialogDescription>
									<p>
										The Scribe feature uses the following privacy architecture:
									</p>
									<ul className="mt-2 list-disc pl-5">
										<li>
											Voice audio data is sent via the native browser /
											operating system SpeechRecognition web standard API (to
											Apple, Google, Microsoft, etc).
										</li>
										<li>
											Only the transcribed text is submitted for processing to
											the Intuizen application.
										</li>
										<li>
											Intuizen does not store or process any raw audio data.
										</li>
									</ul>
									<p>
										Please refer to the intuizen{' '}
										<Link className="underline" to="/data-usage-privacy">
											data usage & privacy policy
										</Link>{' '}
										for more information.
									</p>
								</DialogDescription>
							</DialogHeader>
						</DialogContent>
					</Dialog> */}
				</div>
			</div>
		</div>
	)
}
